import { TextField } from '@mui/material';
import { getFieldControlSx } from '../fieldStyles';
import type { FieldRendererProps } from '../types';

export function MultilineField({
  field,
  className,
  sx,
  hasWhiteFields = false,
  isDisabled,
  isReadOnly,
  autoFocus,
  onChange,
}: FieldRendererProps) {
  return (
    <TextField
      className={className}
      sx={getFieldControlSx(hasWhiteFields, sx)}
      variant="outlined"
      margin="dense"
      disabled={isDisabled}
      autoFocus={autoFocus}
      slotProps={{ htmlInput: { readOnly: isReadOnly }, inputLabel: { shrink: true } }}
      fullWidth
      id={field.id.toString()}
      type={field.type}
      label={field.label}
      required={field.required}
      multiline
      rows={4}
      value={field.value}
      onChange={(event) => onChange(event.target.value || '')}
    />
  );
}
